import { Sidebar } from "./Sidebar";

export const DashboardLayout = ({
  children,
  userType = "admin",
  isInventoryActive = false,
}: {
  children: React.ReactNode;
  userType?: "admin" | "owner";
  isInventoryActive?: boolean;
}) => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar userType={userType} isInventoryActive={isInventoryActive} />
      <main className="flex-1 overflow-x-auto overflow-y-auto p-2 sm:p-4 md:p-6 lg:p-8 ml-[60px] w-full max-w-full">
        <div className="max-w-7xl mx-auto">
          {children}
        </div>
      </main>
    </div>
  );
};